// imports
import { styled, Link } from '@mui/material';
import { LINK_BLUE } from '../../constants/colors';

/**
 * OutlinedLink
 *
 * This link is meant to exactly match the styling of the OutlinedButton, which is used for "CLOSE", etc.
 *
 */
export const OutlinedLink = styled(Link)({
  backgroundColor: 'white',
  color: LINK_BLUE,
  border: `2px solid ${LINK_BLUE}`,
  lineHeight: '2rem',
  padding: '0.375rem 1rem 0.25rem',
  fontWeight: 400,
  textTransform: 'uppercase',
  letterSpacing: '1px',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  textDecoration: 'none',
  display: 'inline-block',
  borderRadius: '4px',
  boxSizing: 'border-box',
  transition: 'background-color 0.2s, color 0.2s',
  '&:hover': {
    backgroundColor: LINK_BLUE,
    color: 'white',
    border: `2px solid ${LINK_BLUE}`,
    textDecoration: 'none',
  },
});
